import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  videosListRequest: ['projectId'],
  videosListSuccess: ['listData'],
  videosListFailure: ['listError'],

  videosCreateRequest: ['createParams'],
  videosCreateSuccess: ['createData'],
  videosCreateFailure: ['createError'],
  videosSetUploadProgress: ['uploadProgress'],

  videosUpdateRequest: ['id', 'updateParams'],
  videosUpdateSuccess: ['updateData'],
  videosUpdateFailure: ['updateError'],

  videosDeleteRequest: ['id'],
  videosDeleteSuccess: ['deleteData'],
  videosDeleteFailure: ['deleteError'],

  videosVersionsRequest: ['videoId'],
  videosVersionsSuccess: ['versionsData'],
  videosVersionsFailure: ['versionsError'],

  videosUnversionRequest: ['id'],
  videosUnversionSuccess: ['unversionData'],
  videosUnversionFailure: ['unversionError'],

  videosSetCurrent: ['videoId'],
  videosSetResolution: ['index'],

  videosSetStatus: ['status'],

  videosSetDragVideoId: ['videoId']
})

export const VideoTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  listData: [],
  listFetching: null,
  listError: null,

  createData: {},
  createFetching: null,
  createError: null,
  uploadProgress: 0,

  updateData: {},
  updateFetching: null,
  updateError: null,

  versionsData: [],
  versionsFetching: null,
  versionsError: null,

  unversionData: {},
  unversionFetching: null,
  unversionError: null,

  currentVideo: null,
  resolution: null,

  versionDropDown: [],

  dragVideoId: null
})

/* ------------- Reducers ------------- */

export const listRequest = (state) =>
  state.merge({ listFetching: true, listError: null })

export const listSuccess = (state, { listData }) =>
  state.merge({ listFetching: false, listData })

export const listFailure = (state, { listError }) => {
  return state.merge({ listFetching: false, listError })
}

export const createRequest = (state) =>
  state.merge({ createFetching: true, createError: null })

export const createSuccess = (state, { createData }) =>
  state.merge({ createFetching: false, createData })

export const createFailure = (state, { createError }) => {
  return state.merge({ createFetching: false, createError })
}

export const setUploadProgress = (state, { uploadProgress }) =>
  state.merge({ uploadProgress })

export const updateRequest = (state) =>
  state.merge({ updateFetching: true, updateError: null })

export const updateSuccess = (state, { updateData }) =>
  state.merge({ updateFetching: false, updateData })

export const updateFailure = (state, { updateError }) => {
  return state.merge({ updateFetching: false, updateError })
}

export const deleteRequest = (state) =>
  state.merge({ deleteFetching: true, deleteError: null })

export const deleteSuccess = (state, { deleteData }) =>
  state.merge({ deleteFetching: false, deleteData })

export const deleteFailure = (state, { deleteError }) => {
  return state.merge({ deleteFetching: false, deleteError })
}

export const versionsRequest = (state) =>
  state.merge({ versionsFetching: true, versionsError: null })

export const versionsSuccess = (state, { versionsData }) =>
  state.merge({
    versionsFetching: false,
    versionsData,
    versionDropDown: versionsData.map((version, index) => ({
      value: version.id, text: 'v' + (index + 1), key: version.id
    }))
  })

export const versionsFailure = (state, { versionsError }) => {
  return state.merge({ versionsFetching: false, versionsError })
}

export const unversionRequest = (state) =>
  state.merge({ unversionFetching: true, unversionError: null })

export const unversionSuccess = (state, { unversionData }) =>
  state.merge({ unversionFetching: false, unversionData })

export const unversionFailure = (state, { unversionError }) => {
  return state.merge({ unversionFetching: false, unversionError })
}

export const setCurrentVideo = (state, { videoId }) => {
  const currentVideo = state.versionsData.find(version => {
    return version.id === videoId
  })
  return state.merge({
    currentVideo,
    resolution: currentVideo.sources.length > 0 ? 1 : null
  })
}

export const setStatus = (state, { status }) => {
  if (!state.currentVideo) return state
  return state.merge({
    currentVideo: state.currentVideo.setIn(['status'], status)
  })
}

export const setResolution = (state, {index}) => {
  return state.merge({resolution: index})
}

export const setDragVideoId = (state, {videoId}) => {
  return state.merge({dragVideoId: videoId})
}

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const VideoSelectors = {
  videosList: state => state.videos.listData,
  videoVersionIds: state => state.videos.versionsData
    .map(version => version.id).join(',')
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.VIDEOS_LIST_REQUEST]: listRequest,
  [Types.VIDEOS_LIST_SUCCESS]: listSuccess,
  [Types.VIDEOS_LIST_FAILURE]: listFailure,

  [Types.VIDEOS_CREATE_REQUEST]: createRequest,
  [Types.VIDEOS_CREATE_SUCCESS]: createSuccess,
  [Types.VIDEOS_CREATE_FAILURE]: createFailure,
  [Types.VIDEOS_SET_UPLOAD_PROGRESS]: setUploadProgress,

  [Types.VIDEOS_UPDATE_REQUEST]: updateRequest,
  [Types.VIDEOS_UPDATE_SUCCESS]: updateSuccess,
  [Types.VIDEOS_UPDATE_FAILURE]: updateFailure,

  [Types.VIDEOS_DELETE_REQUEST]: deleteRequest,
  [Types.VIDEOS_DELETE_SUCCESS]: deleteSuccess,
  [Types.VIDEOS_DELETE_FAILURE]: deleteFailure,

  [Types.VIDEOS_VERSIONS_REQUEST]: versionsRequest,
  [Types.VIDEOS_VERSIONS_SUCCESS]: versionsSuccess,
  [Types.VIDEOS_VERSIONS_FAILURE]: versionsFailure,

  [Types.VIDEOS_UNVERSION_REQUEST]: unversionRequest,
  [Types.VIDEOS_UNVERSION_SUCCESS]: unversionSuccess,
  [Types.VIDEOS_UNVERSION_FAILURE]: unversionFailure,

  [Types.VIDEOS_SET_CURRENT]: setCurrentVideo,
  [Types.VIDEOS_SET_RESOLUTION]: setResolution,
  [Types.VIDEOS_SET_STATUS]: setStatus,
  [Types.VIDEOS_SET_DRAG_VIDEO_ID]: setDragVideoId
})



// WEBPACK FOOTER //
// ./src/Redux/VideoRedux.js